module.exports = __webpack_public_path__ + "img/unnamed.fde76c08.png";